import { createApi } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";

export const subscriptionBillingApi = createApi({
  reducerPath: "subscriptionBillingApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["SubscriptionBilling", "SubscriptionBillings"],

  endpoints: (builder) => ({
    getBillingData: builder.query<any, void>({
      query: () => ({
        url: ApiEndpoints.subscriptionInvoice,
        method: "GET",
      }),
      providesTags: ["SubscriptionBilling"],
    }),
  }),
});
export const { useGetBillingDataQuery } = subscriptionBillingApi;
